import * as actionTypes from './actionTypes'

export const sidebarOpen = () => {
    return {
        type: actionTypes.SIDEBAR_TOGGLE
    }
}

// import * as actionTypes from "./actionTypes";

// export const sidebarOpen = () => {
//   return { type: actionTypes.SIDEBAR_TOGGLE };
// };
